import React from 'react';
import { Chip, alpha } from '@mui/material';
import {
  Edit as DraftIcon,
  HourglassEmpty as PendingIcon,
  CheckCircle as AcceptedIcon,
  PlayArrow as InProgressIcon,
  Done as CompletedIcon,
  Cancel as DeclinedIcon,
  Archive as ArchivedIcon,
} from '@mui/icons-material';

/**
 * TaskStatusBadge Component
 * Displays task status with appropriate color and icon
 */
const TaskStatusBadge = ({ status, size = 'small' }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'draft':
        return {
          label: 'Draft',
          color: '#9e9e9e',
          icon: <DraftIcon sx={{ fontSize: 14 }} />,
        };
      case 'pending_acceptance':
        return {
          label: 'Pending',
          color: '#ff9800',
          icon: <PendingIcon sx={{ fontSize: 14 }} />,
        };
      case 'accepted':
        return {
          label: 'Accepted',
          color: '#2196f3',
          icon: <AcceptedIcon sx={{ fontSize: 14 }} />,
        };
      case 'in_progress':
        return {
          label: 'In Progress',
          color: '#0078b7',
          icon: <InProgressIcon sx={{ fontSize: 14 }} />,
        };
      case 'completed':
        return {
          label: 'Completed',
          color: '#8fc74b',
          icon: <CompletedIcon sx={{ fontSize: 14 }} />,
        };
      case 'declined':
        return {
          label: 'Declined',
          color: '#f44336',
          icon: <DeclinedIcon sx={{ fontSize: 14 }} />,
        };
      case 'archived':
        return {
          label: 'Archived',
          color: '#757575',
          icon: <ArchivedIcon sx={{ fontSize: 14 }} />,
        };
      default:
        return {
          label: status || 'Unknown',
          color: '#9e9e9e',
          icon: null,
        };
    }
  };

  const config = getStatusConfig();

  return (
    <Chip
      icon={config.icon}
      label={config.label}
      size={size}
      sx={{
        backgroundColor: alpha(config.color, 0.1),
        color: config.color,
        border: `1px solid ${alpha(config.color, 0.3)}`,
        fontWeight: 600,
        '& .MuiChip-icon': {
          color: config.color,
        },
      }}
    />
  );
};

export default TaskStatusBadge;
